import { useBrandKitStrategicRecommendations } from 'hooks/queries/brandKits/useBrandKitStrategicRecommendations'
import Styles from './DetailsDrawer.module.scss'

import { DetailsDrawerProps } from './Types'
import { Drawer } from 'components/Drawer'
import { Heading } from 'blaze-ui/Heading/Heading'
import { CHANNEL_LABELS, FEATURE_LABELS } from '../constants'
import { Recommendation } from './Recommendation'

const DetailsDrawer = ({ channelType, feature, brandKitId, ...props }: DetailsDrawerProps) => {
  const { data: strategicRecommendations } = useBrandKitStrategicRecommendations({ brandKitId })

  return (
    <Drawer.Root {...props} activeSnapPoint={1} snapPoints={[1]}>
      <Drawer.Overlay />
      <Drawer.Portal>
        <Drawer.Content fullHeight>
          <Drawer.InnerContent isSnappedTop>
            <Drawer.Top>
              <Drawer.Close position="left" />
              <Drawer.Title />
              <div />
              <Drawer.Description />
            </Drawer.Top>
            <Drawer.ScrollableContainer snap={1}>
              <div className={Styles.content} data-autopilot-system-redesign="on">
                <Heading level={1}>
                  {CHANNEL_LABELS[channelType]} {FEATURE_LABELS[feature]} Recommendations
                </Heading>
                <div className={Styles.recommendations}>
                  {strategicRecommendations
                    ?.filter(
                      (recommendation) =>
                        recommendation.feature === feature && recommendation.channel_type === channelType,
                    )
                    .map((recommendation) => (
                      <Recommendation key={recommendation.id} recommendation={recommendation} brandKitId={brandKitId} />
                    ))}
                </div>
              </div>
            </Drawer.ScrollableContainer>
          </Drawer.InnerContent>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
}

export { DetailsDrawer }
